export enum FILE_TYPES {
    PDF = 'pdf',
    DOC = 'doc',
    DOCX = 'docx',
    PPT = 'ppt',
    PPTX = 'pptx',
    HTML = 'html',
}
